<template>
  <div class="row">
    <div class="col-12">
      <!-- <article v-if="weeksLeftInYear.length > 0" class="fc-m-container"> -->
      <article class="fc-m-container">
        <h2>Start a league</h2>
        <div class="pb-4">
          All settings can be changed after the league is created. By default,
          you will be commissioner of this league.
        </div>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <form @submit="createLeague" id="createLeague">
              <div class="form-group">
                <label for="name">League Name</label>
                <input
                  required
                  class="form-control"
                  type="text"
                  name="name"
                  v-model="name"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="name">Draft Type</label>
                <select
                  required
                  class="form-control"
                  name="draft_type"
                  v-model="draftType"
                >
                  <option disabled value="">Please select an option</option>
                  <option value="Auto">Auto</option>
                  <option value="Manual">Manual</option>
                </select>
                <div class="small text-muted">
                  Choose the type of draft this league will have.
                </div>
              </div>
              <div class="form-group">
                <label for="name">Season Length</label>
                <select
                  required
                  class="form-control"
                  name="season_length"
                  v-model="seasonLength"
                >
                  <option disabled value="">Select number of weeks</option>
                  <option v-bind:value="8">8 weeks</option>
                  <option v-bind:value="12">12 weeks</option>
                  <option v-bind:value="16">16 weeks</option>
                  <option v-bind:value="20">20 weeks</option>
                  <option v-bind:value="24">24 weeks</option>
                </select>
                <div class="small text-muted">
                  Choose the number of weeks in your season. This determines how
                  long your season will last.
                </div>
              </div>
              <div
                v-if="$store.state.auth.account_type == 'individual'"
                class="form-group"
              >
                <label for="invitees">Invite Friends by Email</label>
                <textarea
                  name="invitees"
                  class="form-control"
                  v-model="invitees"
                ></textarea>
                <div class="small text-muted">
                  Invite friends to play in your league by entering their email
                  separated by commas.
                </div>
              </div>
              <div v-else-if="availablePlayers.length" class="form-group">
                <label for="players">Select players</label>
                <select
                  v-model="selectedPlayers"
                  multiple
                  class="form-control"
                  id="players"
                  name="players"
                >
                  <option
                    v-for="player in availablePlayers"
                    :key="player.id"
                    :value="player.id"
                    >{{ player.username }}</option
                  >
                </select>
                <p class="small">
                  Hold <code>Ctrl</code> while clicking to make multiple
                  selections.
                </p>
              </div>

              <loader v-if="submitted" v-bind:embeded="true"></loader>
              <button v-else type="submit" class="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
        </div>
      </article>
      <!-- <article v-else class="fc-m-container">
        <h2>Start a league</h2>
        <div class="alert alert-warning">
          League sign ups are closed for this congress! They will re-open at the
          beginning of the year for the new congress.
        </div>
      </article> -->
    </div>
  </div>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";

export default {
  name: "LeaguesCreate",
  components: {
    loader: Loader
  },
  data: function() {
    return {
      name: "",
      draftType: "",
      seasonLength: "",
      invitees: "",
      submitted: false,
      availablePlayers: [],
      selectedPlayers: []
    };
  },
  created: function() {
    if (this.$store.state.auth.is_customer == false) {
      this.$router.push("/account");
      this.$store.commit("alert/addMessage", {
        message: `Upgrade your account in order to create leagues!`,
        class: "warning",
        persist: false
      });
    }
    if (this.$store.state.auth.account_type == "educator") {
      this.getStudents();
    }
  },
  methods: {
    handleErrors: function(errors) {
      let app = this;
      let errorFields = Object.keys(errors);
      for (let i = 0; i < errorFields.length; i++) {
        if (typeof errors[errorFields[i]] == "object") {
          errors[errorFields[i]] = [errors[errorFields[i]][0]];
        }
        for (let x = 0; x < errors[errorFields[i]].length; x++) {
          let field = errorFields[i];
          app.$store.commit("alert/addMessage", {
            message: `${field}: ${errors[errorFields[i]][x]}`,
            class: "danger",
            persist: false
          });
        }
      }
    },
    getStudents: function() {
      let app = this;

      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/?limit=200`;

      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          app.availablePlayers = response.results.sort((a, b) =>
            a.username.localeCompare(b.username)
          );
        })
        .catch(function(e) {
          app.$store.commit("alert/addMessage", {
            message: `Unable to get students. Please refresh and try again.`,
            class: "warning",
            persist: false
          });
        });
    },
    createLeague: function(e) {
      e.preventDefault();
      this.submitted = true;
      let app = this;

      const csrftoken = getCookie("csrftoken");

      let invitees_list =
        app.invitees == "" ? [] : app.invitees.trim().split(",");
      let invitees_cleaned = invitees_list.filter(email => email != "");

      let form = new URLSearchParams({
        name: app.name,
        draft_type: app.draftType,
        season_length: app.seasonLength
      });

      for (let i = 0; i < invitees_cleaned.length; i++) {
        form.append("invitees", invitees_cleaned[i]);
      }
      for (let i = 0; i < app.selectedPlayers.length; i++) {
        form.append("users", app.selectedPlayers[i]);
      }

      let status = 0;
      fetch(process.env.VUE_APP_PLATFORM + "/api/leagues/", {
        credentials: "include",
        method: "POST",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      })
        .then(function(response) {
          status = response.status;
          app.submitted = false;
          return response.json();
        })
        .then(function(response) {
          if (status == 201) {
            app.$router.push("/leagues/");
            app.$store.commit("alert/addMessage", {
              message: `You created a new league!`,
              class: "success",
              persist: false
            });
          } else {
            app.handleErrors(response);
          }
        })
        .catch(function(e) {
          app.$store.commit("alert/addMessage", {
            message: `Something went wrong. Could not create league.`,
            class: "warning",
            persist: false
          });
        });
    }
  },
  computed: {
    weeksLeftInYear: function() {
      let currentDate = new Date();
      let increment = 7 - currentDate.getDay();
      let nextSunday = currentDate.getTime() + 86400000 * increment;
      let dec31 = new Date(currentDate.getFullYear(), 11, 31);
      let dec31MS = dec31.getTime();
      let timeTilEOY = dec31MS - nextSunday;
      let weeks = parseInt(timeTilEOY / (86400000 * 7)) - 2;
      return weeks > 0 ? Array.from(Array(weeks).keys()) : [];
    }
  }
};
</script>

<style lang="scss"></style>
